import type React from 'react';
import {observer} from 'mobx-react-lite';
import {generatePath, Link as RouterLink} from 'react-router';
import {IconButton, Tooltip} from '@mui/material';
import {SettingsOutlined} from '@mui/icons-material';
import {routes} from '~/routing/routes';
import {useStores} from '~/stores';

/** Gear button to the Category Profile settings; rendered for Mithra staff and customer super users. */
export const SettingsLink: React.FC<{databagId: number}> = observer(({databagId}) => {
    const {authStore} = useStores();
    if (!(authStore.isMithraStaff || authStore.isMithraStaffGroup || authStore.isCustomerSuper)) return null;
    return (
        <Tooltip title="Category Profile settings">
            <IconButton size="small" aria-label="Category Profile settings" component={RouterLink}
                        to={generatePath(routes.category_settings, {id: String(databagId)})}>
                <SettingsOutlined fontSize="small"/>
            </IconButton>
        </Tooltip>
    );
});
